<template>
  <td
    class = "EditableGridCell"
    :class = "{'active': isActive, 'is-editable': isEditable,'has-danger': hasDanger, 'has-padding': hasPadding}">
    <a
      href = "#"
      ref = "cell"
      :class = "{'not-being-edited': !isBeingEdited || !isActive}"
      @focus = "activate"
      @click.prevent
      @dblclick.prevent = "toggleEdit"
      @keydown.enter.stop = "toggleEdit">
      <slot name = "edit" v-if = "isEditable && isBeingEdited && isActive" />
      <slot name = "view" v-else />
      <slot />
    </a>
  </td>
</template>
<script lang = "babel">
  import Vue from 'vue'
  export default{
    name: 'EditableGridCell',

    props: {
      row: Number,
      column: Number,
      activeRow: Number,
      activeColumn: Number,
      isBeingEdited: Boolean,
      isEditable: {
        type: Boolean,
        'default': true
      },
      hasDanger: {
        type: Boolean,
        'default': false
      },
      hasPadding: {
        type: Boolean,
        'default': false
      }
    },

    computed: {
      isActive () {
        return this.row === this.activeRow && this.column === this.activeColumn
      }
    },

    watch: {
      isActive () {
        this.focus()
      },

      isBeingEdited () {
        this.focus()
      }
    },

    methods: {
      activate () {
        this.$parent.$emit('activated', {row: this.row, column: this.column})
      },

      focus () {
        if (this.isActive && this.isBeingEdited) {
          Vue.nextTick(() => {
            let inputs = this.$refs.cell.getElementsByTagName('input')
            let selects = this.$refs.cell.getElementsByTagName('select')
            let buttons = this.$refs.cell.getElementsByTagName('button')

            if (buttons.length > 0) {
              buttons[buttons.length - 1].focus()
            } else if (inputs.length > 0) {
              inputs[inputs.length - 1].focus()
            } else if (selects.length > 0) {
              selects[selects.length - 1].focus()
            }
          })
        } else if (this.isActive && !this.isBeingEdited) {
          this.$refs.cell.focus()
        }
      },

      toggleEdit () {
        if (this.isBeingEdited) {
          this.$parent.$emit('edit', false)
        } else {
          this.$parent.$emit('edit', true)
        }
      }
    }
  }
</script>
<style lang = "scss">
  .EditableGridCell {
    &.active {
      background: #dddddd !important;
    }

    &.has-padding {
      a {
        padding-left: 13px;
      }
    }

    &.is-editable {
      a.not-being-edited {
        padding-left: 13px;
        border-bottom: dashed 1px #0088cc;
        min-height: 37px;
      }

      &.has-danger {
        a.not-being-edited {
          border-bottom: 1px solid red;
          color: red;
        }
      }
    }

    a,
    a:hover,
    a:active {
      outline: none;
      display: block;
      height: 100%;
      width: 100%;
      color: #212529;
      text-decoration: none;
    }

    input,
    select {
      outline: none;
    }
  }
</style>



// WEBPACK FOOTER //
// EditableGridCell.vue?6a022fc0